import React from 'react';

export const ChatMessageAuthor = ({ author }) => (
  <div className="chat--message-author">
    {`${author}:`}
  </div>
);
